// ------------>Domain IP<------------------
// const base_url = "http://165.227.182.6:8000/api";

// ------------>Domain Name<------------------
const base_url = "https://baapis.importkey.com/api";

export default base_url;
